// Session-scoped dismiss flag: once the user closes the ticker it stays hidden for the rest of the
// browser session (same behaviour as the previous single funding banner).
export const ANNOUNCEMENT_BANNER_DISMISSED_KEY = "announcement_banner_dismissed";

// The VerbaIQ "Learn More" navigates in-app to the VerbaIQ (VfCopilot) page. Keep aligned with the
// route registered in featureRouteConfig.ts ("/dashboard/verbaIQ").
export const VERBAIQ_LEARN_MORE_ROUTE = "/dashboard/verbaIQ";

// The EU AI Act "Learn More" opens the external Verbaflo story in a new tab.
export const EU_AI_ACT_LEARN_MORE_URL =
  "https://www.verbaflo.ai/stories/the-eu-ai-act-article-50-what-businesses-need-to-know-right-now";

export const ANNOUNCEMENT_BANNER_CTA_TEXT = "Learn More";

// Trusted, static message HTML — bold segments use `font-semibold` (matches the Figma "SemiBold"
// runs). Injected via dangerouslySetInnerHTML in AnnouncementBanner, so this MUST stay static/trusted.
export const VERBAIQ_SLIDE_MESSAGE_HTML =
  '<strong class="font-semibold">VerbaIQ</strong> is live in beta version. Turn your property data into insights your team can act on.';
export const EU_AI_ACT_SLIDE_MESSAGE_HTML =
  '<strong class="font-semibold">EU AI Act Article 50</strong> is now enforceable. Read our <strong class="font-semibold">whitepaper</strong> on what it means for real estate teams.';

// A slide's "Learn More" is either an in-app route (react-router) or an external URL (new tab).
export type AnnouncementCta =
  | { kind: "internal"; to: string }
  | { kind: "external"; url: string };

export type AnnouncementSlide = {
  id: string;
  // VerbaIQ shows the sparkle icon before its message; EU AI Act has no icon.
  showIcon?: boolean;
  messageHtml: string;
  ctaText: string;
  cta: AnnouncementCta;
};

const EU_AI_ACT_SLIDE: AnnouncementSlide = {
  id: "eu-ai-act",
  messageHtml: EU_AI_ACT_SLIDE_MESSAGE_HTML,
  ctaText: ANNOUNCEMENT_BANNER_CTA_TEXT,
  cta: { kind: "external", url: EU_AI_ACT_LEARN_MORE_URL },
};

const VERBAIQ_SLIDE: AnnouncementSlide = {
  id: "verbaiq",
  showIcon: true,
  messageHtml: VERBAIQ_SLIDE_MESSAGE_HTML,
  ctaText: ANNOUNCEMENT_BANNER_CTA_TEXT,
  cta: { kind: "internal", to: VERBAIQ_LEARN_MORE_ROUTE },
};

// Which slides the ticker shows:
//  - VerbaIQ access (only checkable once logged in) -> a 2-slide carousel [VerbaIQ, EU AI Act].
//  - Otherwise (logged out / no VerbaIQ access) -> a single EU AI Act banner, no carousel.
export const getAnnouncementSlides = (
  isLoggedIn: boolean,
  hasVerbaiqChatAccess: boolean
): AnnouncementSlide[] =>
  isLoggedIn && hasVerbaiqChatAccess
    ? [VERBAIQ_SLIDE, EU_AI_ACT_SLIDE]
    : [EU_AI_ACT_SLIDE];
